import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pedido-fecha-hora"
export default class extends Controller {
  static targets = ["fecha", "hora"]

  static values = {
    min: String,
    max: String,
    readonly: Boolean
  }

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasFechaTarget || !this.hasHoraTarget) return

    if (this.readonlyValue) {
      this.clearErrors()
      return
    }

    if (!this.fechaTarget.value || !this.horaTarget.value) {
      this.clearErrors()
      return
    }

    const selected = this.selectedDateTime()
    const min = this.minValue ? new Date(this.minValue) : null
    const max = this.maxValue ? new Date(this.maxValue) : null

    if (!selected || !min || !max) {
      this.clearErrors()
      return
    }

    if (selected < min || selected > max) {
      const message = "La fecha y hora debe estar entre 2 horas antes y 24 horas despues de la hora actual"
      this.fechaTarget.setCustomValidity(message)
      this.horaTarget.setCustomValidity(message)
      this.horaTarget.reportValidity()
      return
    }

    this.clearErrors()
  }

  selectedDateTime() {
    const dateValue = this.fechaTarget.value
    const timeValue = this.horaTarget.value

    if (!dateValue || !timeValue) return null

    const normalizedTime = timeValue.length === 5 ? `${timeValue}:00` : timeValue
    return new Date(`${dateValue}T${normalizedTime}`)
  }

  clearErrors() {
    this.fechaTarget.setCustomValidity("")
    this.horaTarget.setCustomValidity("")
  }
}
